import React from "react";
import { CircleDollarSign, Leaf, Clock, Zap, ThermometerSun, Building2 } from "lucide-react";
const benefits = [{
  title: "Insurance Savings Opportunity",
  description: "May help qualify for available insurance credits when you have documented wind-resistant features.",
  icon: CircleDollarSign
}, {
  title: "Storm Resilience",
  description: "Identify structural strengths and weaknesses to better protect your family and property.",
  icon: Leaf
}, {
  title: "Fast Reporting",
  description: "Receive your comprehensive inspection report within 24 hours of our site visit.",
  icon: Clock
}, {
  title: "Expert Analysis",
  description: "Certified inspectors evaluate roof-to-wall connections and opening protections.",
  icon: Zap
}, {
  title: "Code Compliance",
  description: "Ensure your home meets the latest Florida building codes for maximum safety.",
  icon: ThermometerSun
}, {
  title: "Property Value",
  description: "Documented wind mitigation features increase the marketability of your South Florida home.",
  icon: Building2
}];
export default function PlatformOverview() {
  return <section data-section-id="248873" id="overview" className="bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-0.5 bg-primary"></div>
              <span className="text-primary font-sans font-bold text-sm uppercase tracking-wider">
                Inspection Benefits
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-[1.1] tracking-tight">
              Protect Your Home and<br className="hidden md:block" /> Save on Insurance
            </h2>
          </div>
          <div className="max-w-lg lg:pb-4">
            <p className="text-muted-foreground font-sans text-lg leading-relaxed">
              A wind mitigation inspection documents the features of your home that help it withstand high winds, potentially saving you thousands in annual premiums.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} className="bg-card rounded-lg p-8 shadow-sm border border-border/40 flex flex-col gap-5 transition-shadow hover:shadow-md">
                <div className="w-12 h-12 rounded-full bg-muted/50 flex items-center justify-center text-primary mb-2">
                  <Icon className="w-6 h-6" strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-xl font-default font-bold text-foreground mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}